import { OPEN_DIVISIONS } from 'constants/event';

export const isOpenEvent = (eventRank) => {
  return OPEN_DIVISIONS.includes(eventRank);
};
